<template>
    <div class="cell-content">
        {{ row.ticket_average / 100 | money }}
        <span
            class="subtext"
        >{{ row.ticket_min / 100 | money }} - {{ row.ticket_max / 100 | money }}</span>
        <span class="subtext">{{ row.ticket_top / 100 | money }}</span>
        <div class="ticket-scale" v-if="scaleTop > 0">
            <div class="ticket-scale-bar" :style="{ width: barWidth, left: barLeft }"/>
            <div
                v-for="tick in ticks"
                :key="tick"
                class="ticket-scale-tick"
                :style="{ left: tickLeft(tick) }"
            />
            <div class="ticket-scale-indicator ticket-average-indicator" :style="{ left: avgLeft }"></div>
            <div
                class="ticket-scale-indicator ticket-top-premium-indicator"
                :style="{ left: topLeft }"
                v-if="row.ticket_top > 0"
            ></div>
            <div class="ticket-scale-zig-zag" v-if="scaleTop < row.ticket_top"></div>
        </div>
    </div>
</template>

<script>
import range from 'lodash/range';

export default {
    props: ['row'],
    computed: {
        barWidth() {
            const range = this.row.ticket_max - this.row.ticket_min;

            return this.percentage(range / this.scaleTop);
        },
        barLeft() {
            return this.percentage(this.row.ticket_min / this.scaleTop);
        },
        avgLeft() {
            return this.percentage(this.row.ticket_average / this.scaleTop);
        },
        topLeft() {
            return this.percentage(this.row.ticket_top / this.scaleTop);
        },
        ticks() {
            const count = Math.floor(this.scaleTop / 100 / 100) + 1;
            return range(1, count);
        },
        scaleTop() {
            if (this.$route.name === 'historical') {
                // Cap it at $500
                return 50000;
            }

            // We're on a show detail page
            const stats = this.$store.getters['shows/aggregate'](
                this.$route.params.show,
            );

            if (!stats) {
                return 0;
            }

            return stats.ticket_top.highest.value;
        },
    },
    methods: {
        percentage(num) {
            return `${Math.min(num * 100, 100)}%`;
        },
        tickLeft(index) {
            const realNumber = index * 100 * 100;
            return this.percentage(realNumber / this.scaleTop);
        },
    },
};
</script>
